<template>
  <div v-if="!$store.getters.getCharts.length">
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="stock-analytics">

      <!-- Dashboard loader -->
      <v-layout row>
        <v-flex xs12>
          <base-loader></base-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div v-else>
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="stock-analytics">

      <!-- Dashboard heading -->
      <v-layout row wrap align-end>
        <v-flex xs12 sm6>
          <last-update-time
            :dashboard-id="id">
          </last-update-time>
        </v-flex>
        <v-flex xs12 sm6>
          <pdf-export
            v-if="pdfExport"
            :dashboard-id="id"
            :dashboard-name="name">
          </pdf-export>
        </v-flex>
      </v-layout>

      <!-- Dashboard filters -->
      <v-layout row wrap>
        <v-flex xs12>
          <filters
            :dashboard-id="id"
            @apply-filters="fetchDashboardData"
            @clear-filters="fetchDashboardData">
          </filters>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <widget-kpi
            number-formatting="number"
            widget-key="VehicleStock_kpiVehiclesOnStock">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm6>
          <widget-kpi
            number-formatting="number"
            widget-key="VehicleStock_kpiDaysOnStock">
          </widget-kpi>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm3>
          <widget-kpi
            number-formatting="price"
            widget-key="VehicleStock_kpiAvgPrice">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm3>
          <widget-kpi
            number-formatting="price"
            widget-key="VehicleStock_kpiTotalPrice">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm3>
          <widget-kpi
            number-formatting="price"
            widget-key="VehicleStock_kpiAvgPriceNew">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm3>
          <widget-kpi
            number-formatting="price"
            widget-key="VehicleStock_kpiTotalPriceNew">
          </widget-kpi>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm3>
          <widget-kpi
            widget-key="VehicleStock_kpiAvgCcm">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm3>
          <widget-kpi
            widget-key="VehicleStock_kpiAvgHp">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm3>
          <widget-kpi
            widget-key="VehicleStock_kpiAvgKm">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm3>
          <widget-kpi
            number-formatting="number" use-decimal
            widget-key="VehicleStock_kpiAvgCo2">
          </widget-kpi>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md6>
          <chart-pie
            chart-key="VehicleStock_VehiclesByStatus"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
        <v-flex xs12 md6>
          <chart-pie
            chart-key="VehicleStock_VehiclesByBrand"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <chart-bar
            chart-key="VehicleStock_VehiclesByModel"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md12>
          <chart-bar
            chart-key="VehicleStock_VehiclesByEnergyClass"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md6>
          <chart-pie
            chart-key="VehicleStock_VehiclesByColor"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
        <v-flex xs12 md6>
          <chart-pie
            chart-key="VehicleStock_VehiclesByColorType"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md6>
          <chart-pie
            chart-key="VehicleStock_VehiclesByFuel"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
        <v-flex xs12 md6>
          <chart-pie
            chart-key="VehicleStock_VehiclesByDriveType"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md12>
          <chart-bar-stacked
            chart-key="VehicleStock_StockByConditionType"
            @open-dialog="openDialog($event)">
          </chart-bar-stacked>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <chart-table
            chart-key="VehicleStock_StockTable"
            @open-dialog="openDialog($event)">
          </chart-table>
        </v-flex>
      </v-layout>
      <!-- row -->
      <!-- chart dialog window -->
      <v-dialog max-width v-model="dialog" @input="closeDialog()">
        <v-card>
          <v-card-title class="subheading">
            {{ dialogTitle }}
            <v-spacer></v-spacer>
            <v-btn icon small class="ma-0" @click.stop="closeDialog()">
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="chart-wrapper">
              <component
                :is="dialogComponent"
                v-bind="dialogProperties"
                :from-dialog="true">
              </component>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus'
import { mapGetters, mapMutations } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
// import am4themesAnimated from '@amcharts/amcharts4/themes/animated'
// import am4themesMaterial from '@amcharts/amcharts4/themes/material'
// import { am4themesEfdThemeAchr } from '@/themes'
// import moment from 'moment'

import BaseLoader from '@/components/loaders/BaseLoader'
import LastUpdateTime from '@/components/LastUpdateTime'
import Filters from './DashboardVehicleStockFiltersGen'
import WidgetKpi from '@/components/charts/WidgetKpi'
import ChartBar from '@/components/charts/ChartBar'
import ChartPie from '@/components/charts/ChartPie'
import ChartLine from '@/components/charts/ChartLine'
import ChartLineDate from '@/components/charts/ChartLineDate'
import ChartLineRender from '@/components/charts/ChartLineRender'
import ChartLineDateRender from '@/components/charts/ChartLineDateRender'
import ChartBarRender from '@/components/charts/ChartBarRender'
import ChartTable from '@/components/charts/ChartTable'
import ChartBarStacked from '@/components/charts/ChartBarStacked'
import ChartBarStackedRender from '@/components/charts/ChartBarStackedRender'
// import { Legend } from '@amcharts/amcharts4/charts'
// import PdfExport from '@/components/pdfExport'

// am4core.useTheme(am4themesAnimated)
// am4core.useTheme(am4themesMaterial)
// am4core.useTheme(am4themesEfdThemeAchr)
am4core.options.queue = true
export default {
  name: 'vehicleStock',
  components: {
    BaseLoader,
    LastUpdateTime,
    Filters,
    WidgetKpi,
    ChartBar,
    ChartPie,
    ChartLine,
    ChartLineRender,
    ChartLineDateRender,
    ChartLineDate,
    ChartBarRender,
    ChartTable,
    ChartBarStacked,
    ChartBarStackedRender
    // PdfExport
  },
  data () {
    return {
      id: 'VehicleStock',
      name: 'VehicleStock',
      charts: [
        {
          key: 'VehicleStock_kpiVehiclesOnStock',
          title: 'chart.title.VehicleStock_kpiVehiclesOnStock',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiDaysOnStock',
          title: 'chart.title.VehicleStock_kpiDaysOnStock',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiAvgPrice',
          title: 'chart.title.VehicleStock_kpiAvgPrice',
          valueType: 'money',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiTotalPrice',
          title: 'chart.title.VehicleStock_kpiTotalPrice',
          valueType: 'money',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiAvgPriceNew',
          title: 'chart.title.VehicleStock_kpiAvgPriceNew',
          valueType: 'money',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiTotalPriceNew',
          title: 'chart.title.VehicleStock_kpiTotalPriceNew',
          valueType: 'money',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiAvgCcm',
          title: 'chart.title.VehicleStock_kpiAvgCcm',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiAvgHp',
          title: 'chart.title.VehicleStock_kpiAvgHp',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiAvgKm',
          title: 'chart.title.VehicleStock_kpiAvgKm',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_kpiAvgCo2',
          title: 'chart.title.VehicleStock_kpiAvgCo2',
          loaded: false,
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'VehicleStock_VehiclesByBrand',
          title: 'chart.title.VehicleStock_VehiclesByBrand',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legendAlwaysShow: true,
            switchToLegendBelow: 50,
            // height: 500,
            noPieLabelsPadding: false,
            hidePercentValuesBelow: 5, // percent
            legendItemsPaddingTop: 10,
            legendItemsPaddingBottom: 2,
            legendFontSize: 16,
            markerTemplateWidth: 8,
            markerTemplateHeight: 8
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value',
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'VehicleStock_VehiclesByStatus',
          title: 'chart.title.VehicleStock_VehiclesByStatus',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legendAlwaysShow: true,
            switchToLegendBelow: 50,
            // height: 500,
            noPieLabelsPadding: false,
            hidePercentValuesBelow: 5, // percent
            legendItemsPaddingTop: 10,
            legendItemsPaddingBottom: 2,
            legendFontSize: 16,
            markerTemplateWidth: 8,
            markerTemplateHeight: 8
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value',
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'VehicleStock_VehiclesByModel',
          title: 'chart.title.VehicleStock_VehiclesByModel',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value',
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'VehicleStock_VehiclesByEnergyClass',
          title: 'chart.title.VehicleStock_VehiclesByEnergyClass',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 15, // override number of displayed columns
            rotate: true, // set columns horisontal
            maxLabelWidth: 400,
            chartHeight: 500 // override chart height in px
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value',
            totalItems: 8,
            page: 1,
            rowsPerPage: 8
          }
        },
        {
          key: 'VehicleStock_VehiclesByColor',
          title: 'chart.title.VehicleStock_VehiclesByColor',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legendAlwaysShow: true,
            switchToLegendBelow: 50,
            // height: 500,
            noPieLabelsPadding: false,
            hidePercentValuesBelow: 5, // percent
            legendItemsPaddingTop: 10,
            legendItemsPaddingBottom: 2,
            legendFontSize: 16,
            markerTemplateWidth: 8,
            markerTemplateHeight: 8
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value',
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'VehicleStock_VehiclesByColorType',
          title: 'chart.title.VehicleStock_VehiclesByColorType',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legendAlwaysShow: true,
            switchToLegendBelow: 50,
            // height: 500,
            noPieLabelsPadding: false,
            hidePercentValuesBelow: 5, // percent
            legendItemsPaddingTop: 10,
            legendItemsPaddingBottom: 2,
            legendFontSize: 16,
            markerTemplateWidth: 8,
            markerTemplateHeight: 8
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value',
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'VehicleStock_VehiclesByFuel',
          title: 'chart.title.VehicleStock_VehiclesByFuel',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legendAlwaysShow: true,
            switchToLegendBelow: 50,
            // height: 500,
            noPieLabelsPadding: false,
            hidePercentValuesBelow: 5, // percent
            legendItemsPaddingTop: 10,
            legendItemsPaddingBottom: 2,
            legendFontSize: 16,
            markerTemplateWidth: 8,
            markerTemplateHeight: 8
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value',
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'VehicleStock_VehiclesByDriveType',
          title: 'chart.title.VehicleStock_VehiclesByDriveType',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legendAlwaysShow: true,
            switchToLegendBelow: 50,
            // height: 500,
            noPieLabelsPadding: false,
            hidePercentValuesBelow: 5, // percent
            legendItemsPaddingTop: 10,
            legendItemsPaddingBottom: 2,
            legendFontSize: 16,
            markerTemplateWidth: 8,
            markerTemplateHeight: 8
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value',
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'VehicleStock_StockByConditionType',
          title: 'chart.title.VehicleStock_StockByConditionType',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legend: true,
            chartHeight: 700,
            translation: true
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: null,
            page: 1/* ,
            rowsPerPage: 25 */
          }
        },
        {
          key: 'VehicleStock_StockTable',
          title: 'chart.title.VehicleStock_StockTable',
          loaded: false,
          export: true,
          exportDetailed: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 10
          }
        }
      ],
      pdfExport: false,
      // dialog data
      dialog: false,
      dialogComponent: '',
      dialogTitle: '',
      dialogProperties: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedFiltersGen', 'getCharts', 'getChartByKey', 'translation', 'currency'
    ]),
    translatedChartTitles: {
      get () {
        return this.charts.map(chart => {
          chart.valueType && chart.valueType === 'money'
            ? chart.title = this.translation(chart.title, { currency: this.currency })
            : chart.title = this.translation(chart.title)
          return chart
        })
      }
    }
  },
  created () {
    this.setCharts(this.translatedChartTitles)
  },
  mounted () {
    this.fetchDashboardData()
  },
  beforeDestroy () {
    // empty charts from store
    this.setCharts([])
  },
  methods: {
    ...mapMutations({
      setCharts: 'SET_CHARTS'
    }),
    fetchDashboardData () {
      // emit event for fetching data from components
      eventBus.$emit('update-dashboard')
    },
    openDialog (dialogData) {
      this.$store.dispatch('fetchChartData', {
        key: dialogData.chartObj.key,
        settings: dialogData.chartObj.settings,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: { ...dialogData.chartObj.pagination, rowsPerPage: dialogData.chartObj.data.metadata.total }
      }).then(() => {
        this.$log.info('dialogData', dialogData)
        // assign received data from clicked component to Dialog component
        this.dialogComponent = dialogData.chartType
        this.dialogProperties = {}
        this.dialogProperties = { chartKey: dialogData.chartObj.key }
        this.dialogTitle = this.getChartByKey(dialogData.chartObj.key).title
        this.dialog = true
      })
    },
    closeDialog () {
      // clear data for component
      this.dialogComponent = ''
      this.dialogProperties = {}
      this.dialogTitle = ''
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .ffu-analytics {
  }
  .lib-link a{
    text-decoration: none;
  }
  @media only screen and (max-device-width: 700px) {
    .ffu-analytics {
    }
  }
</style>
